import { Table } from "@tanstack/react-table";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import { Meta } from "@/@types/paginated";
import { useFilterState } from "../../ducks/filter/hooks/filterState";
import { useUserFilterActions } from "../../ducks/filter/hooks/actions";

interface DataTablePaginationProps<TData> {
  table: Table<TData>;
  meta: Meta;
}

export function DataTablePagination<TData>({
  table,
  meta,
}: DataTablePaginationProps<TData>) {
  const filterState = useFilterState();
  const { updateFilter } = useUserFilterActions();
  const { filters } = filterState || { filters: {} };
  return (
    <div className="flex items-center justify-between px-2">
      <div className="flex-1 text-sm text-muted-foreground">
        {table.getFilteredRowModel().rows.length} linha(s) encontrada(s).
      </div>
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex items-center space-x-2">
        </div>
        <div className="flex w-[100px] items-center justify-center text-sm font-medium">
          Página {meta?.currentPage} de {meta?.lastPage}
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            className="hidden h-8 w-8 p-0 lg:flex"
            onClick={() => {
              updateFilter({
                key: "meta",
                value: { page: 1 },
              });
            }}
            disabled={meta.prev === null}
          >
            <span className="sr-only">Ir para a primeira página</span>
            <ChevronsLeft />
          </Button>
          <Button
            variant="outline"
            className="h-8 w-8 p-0"
            onClick={() => {
              updateFilter({
                key: "meta",
                value: { page: filters.meta.page - 1 || 1 },
              });
            }}
            disabled={meta.prev === null}
          >
            <span className="sr-only">Ir para a página anterior</span>
            <ChevronLeft />
          </Button>
          <Button
            variant="outline"
            className="h-8 w-8 p-0"
            onClick={() => {
              updateFilter({
                key: "meta",
                value: { page: filters.meta.page + 1 || 1 },
              });
            }}
            disabled={meta.next === null}
          >
            <span className="sr-only">Ir para a próxima página</span>
            <ChevronRight />
          </Button>
          <Button
            variant="outline"
            className="hidden h-8 w-8 p-0 lg:flex"
            onClick={() => {
              updateFilter({
                key: "meta",
                value: { page: meta.lastPage },
              });
            }}
            disabled={meta.next === null}
          >
            <span className="sr-only">Ir para a última página</span>
            <ChevronsRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
